import _extends from 'babel-runtime/helpers/extends';

import { mapMutations, mapState, mapActions } from 'vuex';
import PreviewAction from '../components/preview-action.vue';
import PreviewDevice from '@/components/PreviewDevice/index.vue';
import SceneSwitch from '../components/scene-switch.vue';
import PreviewTemplateButton from '../components/preview-template-button.vue';
import VolumeController from '../components/volume-controller.vue';
import SaveButton from './save-button.vue';
import PublishCustomToPt from './publish-custom-to-pt.vue';
import PreviewUrlQrcode from '../components/preview-url-qrcode.vue';
import PlPointLayer from '@com/components/pl-point-layer/index';

export default {
  components: {
    PreviewAction: PreviewAction,
    PreviewDevice: PreviewDevice,
    PreviewTemplateButton: PreviewTemplateButton,
    SceneSwitch: SceneSwitch,
    VolumeController: VolumeController,
    SaveButton: SaveButton,
    PublishCustomToPt: PublishCustomToPt,
    PreviewUrlQrcode: PreviewUrlQrcode,
    PlPointLayer: PlPointLayer
  },

  props: {
    url: {
      type: String,
      required: true
    },

    validate: {
      type: Function,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      audioLoopTimer: null
    };
  },


  computed: _extends({}, mapState({
    templateId: function templateId(state) {
      return state.creative.template.id;
    },
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig || {};
    },
    previewer: function previewer(state) {
      return state.creative.template.previewer;
    },
    activeCategoryId: function activeCategoryId(state) {
      return state.creative.template.activeCategoryId;
    },
    workSpaceSetting: function workSpaceSetting(state) {
      return state.creative.template.workSpaceSetting;
    },
    canLivePreview: function canLivePreview(state) {
      return state.creative.template.canLivePreview;
    },
    isV2: function isV2(state) {
      return state.creative.template.isV2;
    },
    isReadonly: function isReadonly(state) {
      return state.creative.template.isReadonly;
    },
    adaptDatas: function adaptDatas(state) {
      return state.creative.modelEditor.cameraAdaptConfig.adapt.adaptDatas;
    },
    orbitParams: function orbitParams(state) {
      return state.creative.modelEditor.cameraAdaptConfig.orbitParams;
    },
    preparingPreview: function preparingPreview(state) {
      return state.creative.template.preparingPreview;
    }
  }), {
    innerUrl: function innerUrl() {
      return this.url;
    },
    actions: function actions() {
      // 后端接口字段会覆盖，导致使用actions2字段
      return this.templateConfig.actions2 || {};
    },


    condition: {
      get: function get() {
        var template = this.$store.state.creative.template;
        return {
          orientation: template.orientation,
          deviceType: template.device
        };
      },
      set: function set(_ref) {
        var orientation = _ref.orientation,
            deviceType = _ref.deviceType;

        orientation && this.updateOrientation(orientation);
        deviceType && this.updateDevice(deviceType);
      }
    }
  }),
  watch: {
    $route: function $route() {
      var _this = this;

      this.audioLoopTimer && clearInterval(this.audioLoopTimer);
      this.$nextTick(function () {
        _this.updateIframe(document.getElementById('preview-device-iframe'));
      });
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.updateIframe(document.getElementById('preview-device-iframe'));
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.audioLoopTimer && clearInterval(this.audioLoopTimer);
  },


  methods: _extends({}, mapMutations({
    updateIframe: 'creative/template/previewer/updateIframe',
    updateDevice: 'creative/template/updateDevice',
    updateOrientation: 'creative/template/updateOrientation'
  }), mapActions({
    previewActiveScene: 'creative/template/previewer/previewActiveScene',
    updateWorkSpaceSetting: 'creative/template/updateWorkSpaceSetting',
    stopAudio: 'creative/template/previewer/stopAudio',
    recoveryAudio: 'creative/template/previewer/recoveryAudio'
  }), {
    handleSwitchScene: function handleSwitchScene(_ref2) {
      var scene = _ref2.scene;

      this.switchScene(scene);
    },
    initAudioState: function initAudioState() {
      if (this.workSpaceSetting.toolbar_isMuted) {
        this.mute();
      } else {
        this.unmute();
      }
    },
    mute: function mute() {
      this.stopAudio();
      this.updateWorkSpaceSetting({
        toolbar_isMuted: true
      });
    },
    unmute: function unmute() {
      this.recoveryAudio();
      this.updateWorkSpaceSetting({
        toolbar_isMuted: false
      });
    },
    switchScene: function switchScene(scene) {
      if (this.previewer.gameReady) {
        this.previewActiveScene(scene);
      } else {
        this.$message.info(this.$t('playTurbo.custom.previewer.loadingText'));
      }
    }
  })
};